export default "__VITE_ASSET__09f1cf85__"